// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2j04J","validationTips":"StatementDescriptor_validationTips__3Qe42"};